import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiUrl from "../../Environment/Api";
import { FaFilePdf } from "react-icons/fa";
import html2pdf from "html2pdf.js";

const InvoicePrint = () => {
  const { invoice_id } = useParams();
  const navigate = useNavigate();
  const printRef = useRef();

  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Function to convert number to words (Indian Rupees format)
  // const convertToWords = (num) => {
  //   if (num === 0 || isNaN(num)) return "Zero Rupees Only";

  //   const ones = [
  //     "",
  //     "One",
  //     "Two",
  //     "Three",
  //     "Four",
  //     "Five",
  //     "Six",
  //     "Seven",
  //     "Eight",
  //     "Nine",
  //     "Ten",
  //     "Eleven",
  //     "Twelve",
  //     "Thirteen",
  //     "Fourteen",
  //     "Fifteen",
  //     "Sixteen",
  //     "Seventeen",
  //     "Eighteen",
  //     "Nineteen",
  //   ];
  //   const tens = [
  //     "",
  //     "",
  //     "Twenty",
  //     "Thirty",
  //     "Forty",
  //     "Fifty",
  //     "Sixty",
  //     "Seventy",
  //     "Eighty",
  //     "Ninety",
  //   ];

  //   const numToWords = (n) => {
  //     if (n < 20) return ones[n];
  //     if (n < 100)
  //       return (
  //         tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
  //       );
  //     if (n < 1000)
  //       return (
  //         ones[Math.floor(n / 100)] +
  //         " Hundred" +
  //         (n % 100 !== 0 ? " " + numToWords(n % 100) : "")
  //       );
  //     if (n < 100000)
  //       return (
  //         numToWords(Math.floor(n / 1000)) +
  //         " Thousand" +
  //         (n % 1000 !== 0 ? " " + numToWords(n % 1000) : "")
  //       );
  //     if (n < 10000000)
  //       return (
  //         numToWords(Math.floor(n / 100000)) +
  //         " Lakh" +
  //         (n % 100000 !== 0 ? " " + numToWords(n % 100000) : "")
  //       );
  //     return (
  //       numToWords(Math.floor(n / 10000000)) +
  //       " Crore" +
  //       (n % 10000000 !== 0 ? " " + numToWords(n % 10000000) : "")
  //     );
  //   };

  //   const rupees = Math.floor(num);
  //   const paise = Math.round((num - rupees) * 100);

  //   let result = numToWords(rupees) + " Rupees";
  //   // if (paise > 0) {
  //   //   result += " and " + numToWords(paise) + " Paise";
  //   // }
  //   return result + " Only";
  // };

  const convertToWords = (num, countrycode) => {
    if (num === 0 || isNaN(num)) {
      return countrycode === "91" ? "Zero Rupees Only" : "Zero Dollars Only";
    }

    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const numToWords = (n) => {
      if (n < 20) return ones[n];
      if (n < 100)
        return (
          tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
        );

      if (n < 1000)
        return (
          ones[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 !== 0 ? " " + numToWords(n % 100) : "")
        );

      if (n < 100000)
        return (
          numToWords(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 !== 0 ? " " + numToWords(n % 1000) : "")
        );

      if (n < 10000000)
        return (
          numToWords(Math.floor(n / 100000)) +
          " Lakh" +
          (n % 100000 !== 0 ? " " + numToWords(n % 100000) : "")
        );

      return (
        numToWords(Math.floor(n / 10000000)) +
        " Crore" +
        (n % 10000000 !== 0 ? " " + numToWords(n % 10000000) : "")
      );
    };

    const whole = Math.floor(num);
    const decimal = Math.round((num - whole) * 100);

    // 🇮🇳 INR
    if (countrycode === "91") {
      let result = numToWords(whole) + " Rupees";
      return result + " Only";
    }

    // 🌍 USD
    let result = numToWords(whole) + " Dollars";

    if (decimal > 0) {
      result += " and " + numToWords(decimal) + " Cents";
    }

    return result + " Only";
  };

  // Calculate totals from editors array
  // const calculateTotals = (editors) => {
  //   let subtotal = 0;
  //   let taxTotal = 0;
  //   let netTotal = 0;

  //   (editors || []).forEach((item) => {
  //     const price = parseFloat(item.price) || 0;
  //     const totalAmount = parseFloat(item.totalAmount) || 0;

  //     subtotal += price;
  //     netTotal += totalAmount;
  //     taxTotal += totalAmount - price;
  //   });

  //   return { subtotal, taxTotal, netTotal };
  // };

  const calculateTotals = (editors, countrycode) => {
    let subtotal = 0;
    let taxTotal = 0;
    let netTotal = 0;

    (editors || []).forEach((item) => {
      const rate = parseFloat(item.rate) || 0;
      const taxRate = parseFloat(item.tax) || 0;
      const price = parseFloat(item.price) || 0;
      const totalAmount = parseFloat(item.totalAmount) || 0;

      if (countrycode === "91") {
        // INDIA → EXISTING LOGIC (₹)
        subtotal += price;
        netTotal += totalAmount;
        taxTotal += totalAmount - price;
      } else {
        // OTHER COUNTRIES → USD LOGIC
        subtotal += rate;
        taxTotal += (rate * taxRate) / 100;
      }
    });

    if (countrycode !== "91") {
      netTotal = subtotal + taxTotal;
    }

    return { subtotal, taxTotal, netTotal };
  };

  // Fetch data based on invoice_id
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/invoicelist`);
      const allInvoices = response.data;

      // Find the invoice with matching invoiceId
      const foundInvoice = allInvoices.find(
        (invoice) => invoice.invoiceId === invoice_id,
      );

      if (foundInvoice) {
        setInvoiceData(foundInvoice);
      } else {
        console.error("Invoice not found");
      }
    } catch (error) {
      console.log("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (invoice_id) {
      fetchData();
    }
  }, [invoice_id]);

  // Auto open print dialog
  useEffect(() => {
    if (!loading && invoiceData) {
      setTimeout(() => {
        window.print();
      }, 500);
    }
  }, [loading, invoiceData]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!invoiceData) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger text-center">
          <h4>Invoice not found!</h4>
          <button
            className="btn btn-primary mt-3"
            onClick={() => navigate("/invoice")}
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  // const { subtotal, taxTotal, netTotal } = calculateTotals(invoiceData.editors);

  const { subtotal, taxTotal, netTotal } = calculateTotals(
    invoiceData.editors,
    invoiceData.countrycode,
  );

  // PDF downlode
  const handleDownloadPDF = () => {
    const element = printRef.current;

    const opt = {
      margin: 0.3,
      filename: `Invoice_${invoiceData.invoiceId}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(opt).from(element).save();
  };

  return (
    <>
      <style>
        {`
          @media print {
            body {
              margin: 0;
              padding: 0;
              background: white;
            }
            .no-print {
              display: none !important;
            }
            .print-container {
              margin: 0;
              padding: 0;
              width: 100%;
            }
            .card {
              box-shadow: none !important;
              border: none !important;
            }
            .table-bordered {
              border: 1px solid #dee2e6 !important;
            }
            .table-bordered th,
            .table-bordered td {
              border: 1px solid #dee2e6 !important;
            }
            .bg-light {
              background-color: #f8f9fa !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            .table-dark {
              background-color: #212529 !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              color: white;
            }
            .text-success {
              color: #198754 !important;
            }
          }
          
          @page {
            size: A4;
          }
          
          .print-container {
            max-width: 1100px;
            margin: 0 auto;
            background: white;
          }
          
          @media screen {
            .print-container {
              margin: 20px auto;
              box-shadow: 0 0 10px rgba(0,0,0,0.1);
            }

            .footer-content{
            display: flex;
            align-items : end;
            justify-content: center;
            fonst-size: 8px;
            }
          }
        `}
      </style>

      {/* Back Button */}
      <div className="d-flex justify-content-end gap-3 me-5 my-3 no-print">
        <button className="btn btn-dark" onClick={handleDownloadPDF}>
          <FaFilePdf /> PDF
        </button>
        <button className="btn btn-danger" onClick={() => navigate("/invoice")}>
          ← Back
        </button>
      </div>

      {/* Invoice Container - A4 Optimized */}
      <div className="print-container" ref={printRef}>
        <div className="card shadow-sm border-0">
          <div className="card-body p-4 p-md-5">
            {/* Header Section */}
            <div className="row align-items-center mb-4">
              <div className="col-4">
                <img
                  src={require("../../../assets/img/Admin/edffsd.png")}
                  y
                  alt="Logo"
                  style={{ maxWidth: "120px", height: "auto" }}
                />
              </div>
              <div className="col-4 text-center">
                <h3 className="mb-0 fw-bold">INVOICE</h3>
              </div>
              <div className="col-4">
                <div className="border-start ps-3">
                  <div className="mb-2">
                    <strong>Invoice No:</strong> {invoiceData.invoiceId}
                  </div>
                  <div className="mb-2">
                    <strong>Invoice Date:</strong>{" "}
                    {new Date().toLocaleDateString("en-GB")}
                  </div>
                  <div className="mb-2">
                    <strong>Due Date:</strong>{" "}
                    {invoiceData.dueDate
                      ? new Date(invoiceData.dueDate).toLocaleDateString(
                          "en-GB",
                        )
                      : ""}
                  </div>
                </div>
              </div>
            </div>

            <hr />

            {/* Client Details Section */}
            <div className="row mb-5">
              <div className="col-md-4 col-sm-4">
                <h6 className="fw-bold mb-2">Click On</h6>
                <div className="ps-3">
                  <p className="mb-1">
                    <strong>Rajkumar</strong>
                  </p>
                  <p className="mb-1">
                    <i className="fa-solid fa-phone me-2"></i> +91 9600895918
                  </p>
                  <p className="mb-0">
                    <i className="fa-solid fa-location-dot me-2"></i>
                    Salem-306, TamilNadu, South india.
                  </p>
                </div>
              </div>

              <div className="col-2 col-sm-2"></div>
              <div className="col-md-6 col-sm-6 text-end">
                <h6 className="fw-bold mb-2">Bill To:</h6>
                <div className="ps-3">
                  <p className="mb-1">
                    {/* <i className="fa-solid fa-user"></i>{" "} */}
                    <span className="fw-semibold">Name</span>
                    {" - "}
                    {invoiceData.client_name || "N/A"}
                  </p>
                  <p className="mb-0">
                    {/* <i className="fa-solid fa-location-dot"></i>{" "} */}
                    <span className="fw-semibold">Address</span>
                    {" - "}
                    {invoiceData.client_address || "N/A"}
                  </p>
                </div>
              </div>
            </div>

            {/* Table Section */}
            <div className="table-responsive mb-4">
              <table className="table table-hover text-center">
                <thead className="table-dark">
                  <tr>
                    <th style={{ width: "5%" }}>#</th>
                    <th style={{ width: "12%" }}>Date</th>
                    <th style={{ width: "12%" }}>Address</th>
                    <th style={{ width: "10%" }}>Qty</th>
                    {invoiceData.countrycode !== "91" && (
                      <th style={{ width: "10%" }}>Rate ($)</th>
                    )}

                    <th style={{ width: "8%" }}>Tax %</th>
                    {invoiceData.countrycode === "91" && (
                      <th style={{ width: "12%" }}>Price (₹)</th>
                    )}
                    <th style={{ width: "12%" }}>
                      Amount ({invoiceData.countrycode === "91" ? "₹" : "$"})
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceData?.editors && invoiceData.editors.length > 0 ? (
                    invoiceData.editors.map((item, index) => {
                      const totalVal =
                        Number(item.standard || 0) +
                        Number(item.premier || 0) +
                        Number(item.twilight || 0) +
                        Number(item.day_to_dusk || 0) +
                        Number(item.vra || 0) +
                        Number(item.vr || 0) +
                        Number(item.col7 || 0) +
                        Number(item.col8 || 0) +
                        Number(item.col9 || 0) +
                        Number(item.col10 || 0) +
                        Number(item.col11 || 0) +
                        Number(item.col12 || 0);

                      return (
                        <tr key={item.id || index}>
                          <td>{index + 1}</td>
                          <td>
                            {item.date
                              ? new Date(item.date).toLocaleDateString("en-GB")
                              : "N/A"}
                          </td>
                          <td>{item.projectName || "N/A"}</td>
                          <td>{totalVal || "0"}</td>
                          {invoiceData.countrycode !== "91" && (
                            <td>{parseFloat(item.rate || 0).toFixed(2)}</td>
                          )}
                          <td>{item.tax || "0"}%</td>

                          {/* {item.countrycode === "91" && (
                            <td>{parseFloat(item.price || 0).toFixed(2)}</td>
                          )} */}

                          {invoiceData.countrycode === "91" && (
                            <td>{parseFloat(item.price || 0).toFixed(2)}</td>
                          )}

                          {invoiceData.countrycode === "91" ? (
                            <td>
                              {(
                                parseFloat(item.price || 0) +
                                (parseFloat(item.price || 0) *
                                  parseFloat(item.tax || 0)) /
                                  100
                              ).toFixed(2)}
                            </td>
                          ) : (
                            <td>
                              {(
                                parseFloat(item.rate || 0) +
                                (parseFloat(item.rate || 0) *
                                  parseFloat(item.tax || 0)) /
                                  100
                              ).toFixed(2)}
                            </td>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        No items found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Totals Section */}
            <div className="row mt-4">
              <div className="col-md-6 col-sm-6">
                <div className="">
                  <strong className="d-block mb-2">Amount In Words:</strong>
                  <p
                    className="mb-0"
                    style={{ fontSize: "14px", lineHeight: "1.5" }}
                  >
                    {convertToWords(netTotal, invoiceData.countrycode)}
                  </p>
                </div>
                <div className="mt-3">
                  <strong className="d-block mb-2">Notes:</strong>
                  <p
                    className="mb-0"
                    style={{ fontSize: "14px", lineHeight: "1" }}
                  >
                    {invoiceData.editors?.[0]?.notes || "No Notes"}
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-sm-6">
                <div className="border rounded p-3">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Sub Total:</span>
                    <strong>
                      {invoiceData.countrycode === "91" ? "₹" : "$"}{" "}
                      {subtotal.toFixed(2)}
                    </strong>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Paypal Tax:</span>
                    <strong>
                      {invoiceData.countrycode === "91" ? "₹" : "$"}{" "}
                      {taxTotal.toFixed(2)}
                    </strong>
                  </div>
                  <div className="d-flex justify-content-between pt-2 mt-2 border-top">
                    <span className="fw-bold fs-5">Net Total:</span>
                    <span className="fw-bold fs-5 text-success">
                      {invoiceData.countrycode === "91" ? "₹" : "$"}{" "}
                      {invoiceData.countrycode === "91"
                        ? Math.round(netTotal).toFixed(2)
                        : netTotal.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="d-flex justify-content-center align-items-end footer-content">
            <span className="text-muted fs-6">
              -- Developed By Aalan Tech Soft --
            </span>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default InvoicePrint;
